

























































































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { LinkLabel } from '~/modules/catalog/product/composables/useProductHandler/useProductHandler';
import { SfImage } from '~/components/StorefrontUi';
import { addBasePath } from '~/helpers/addBasePath';
import InfoWithIcon from '~/components/InfoWithIcon.vue';

export default defineComponent({
  name: 'ProductAdditionalFields',
  components: { SfImage, InfoWithIcon },
  props: {
    fields: {
      type: Array as PropType<{ label: string; value: string }[]>,
      default: () => [],
    },
    delivery: {
      type: String as PropType<string>,
      default: '',
    },
    benefits: {
      type: Array as PropType<LinkLabel[]>,
      default: () => [],
    },
  },
  methods: { addBasePath },
});
